import React, { useState, useEffect, useRef } from 'react';
import './TelaRelatorio.css';
import { RiDownload2Fill } from 'react-icons/ri';
import CheckboxPadrao from '../CheckboxPadrao/CheckboxPadrao';
import TogglePadrao from '../TogglePadrao/TogglePadrao';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import ContainerPadrao from '../ContainerPadrao/ContainerPadrao';
import CabecalhoPadrao from '../CabecalhoPadrao/CabecalhoPadrao';
import { salvarCache, recuperarCache, removerCache } from '../../services/cacheHandler';
import DatePickerPadrao from './DatePickerPadrao';

export class TelaRelatorioKeys {
    static PESSOA = 'relatorio_pessoa';
    static AUDITORIA = 'relatorio_auditoria';
}

const TelaRelatorio = ({
    tituloPagina,
    tituloContainer,
    subtituloContainer,
    tituloContainerPeriodo,
    subtituloContainerPeriodo,
    exibeContainerPeriodo = true,
    dataInicio,           
    horaFinal,            
    onChangeDataInicio,   
    onChangeHoraFinal,    
    configOptions = [],
    onConfigChange = () => {},
    gerarRelatorio,
    children,
    conteudoExclusivoEsquerda,
    storageKey,
    salvarConfigInicial = false,
    configSelecionadasInicial = [],
    componenteConfigExtra = null, 
}) => {
    const [configMap, setConfigMap] = useState(() => {
        const map = new Map();
        configSelecionadasInicial.forEach(id => {
            const opt = configOptions.find(opt => opt.value === id);
            if (opt) map.set(opt.value, { id: opt.value });
        });
        return map;
    });
    const [salvarConfig, setSalvarConfig] = useState(salvarConfigInicial);

    // Estado para saber se já carregou as configs iniciais
    const [carregouConfigInicial, setCarregouConfigInicial] = useState(false);

    // Estado para saber se o usuário interagiu com o switch
    const [usuarioInteragiuComSwitch, setUsuarioInteragiuComSwitch] = useState(false);

    // Flag para garantir sincronização inicial única
    const sincronizouComCacheRef = useRef(false);

    // Sincroniza switch e checkboxes com o cache apenas uma vez após carregamento
    useEffect(() => {
        if (
            carregouConfigInicial &&
            !usuarioInteragiuComSwitch &&
            !sincronizouComCacheRef.current
        ) {
            setSalvarConfig(salvarConfigInicial);
            const arrAtual = Array.from(configMap.keys());
            const arrNovo = Array.isArray(configSelecionadasInicial) ? configSelecionadasInicial : [];
            const mudou = arrAtual.length !== arrNovo.length || arrAtual.some((v, i) => v !== arrNovo[i]);
            if (mudou) {
                const map = new Map();
                arrNovo.forEach(id => {
                    const opt = configOptions.find(opt => opt.value === id);
                    if (opt) map.set(opt.value, { id: opt.value });
                });
                setConfigMap(map);
            }
            sincronizouComCacheRef.current = true;
        }
    }, [carregouConfigInicial, configSelecionadasInicial, configOptions, usuarioInteragiuComSwitch, salvarConfigInicial, configMap]);

    // Salvar config no localStorage ao mudar configMap e salvarConfig
    useEffect(() => {
        const arr = Array.from(configMap.keys());
        if (salvarConfig && arr.length > 0) {
            salvarCache(storageKey, JSON.stringify(arr));
        }
    }, [configMap, salvarConfig, storageKey]);

    // Sincroniza estado inicial com o cache, se disponível
    useEffect(() => {
        const cachedValue = recuperarCache(storageKey);
        if (cachedValue) {
            try {
                const parsed = JSON.parse(cachedValue);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    const map = new Map();
                    parsed.forEach(id => {
                        const opt = configOptions.find(opt => opt.value === id);
                        if (opt) map.set(opt.value, { id: opt.value });
                    });
                    setConfigMap(map);
                    setSalvarConfig(true); // Marca o switch se restaurou opções do cache
                }
            } catch (e) {
                console.error("Erro ao parsear o cache do relatório:", e);
            }
        }
    }, [storageKey, configOptions]);

    // Handler para o switch
    const handleSwitchChange = (e) => {
        setUsuarioInteragiuComSwitch(true);
        setSalvarConfig(e.target.checked);
    };

    // Remove do localStorage ao desmarcar o switch, mas só se o usuário interagiu
    useEffect(() => {
        if (
            usuarioInteragiuComSwitch &&
            !salvarConfig &&
            Array.isArray(configSelecionadasInicial)
        ) {
            removerCache(storageKey);
        }
    }, [salvarConfig, storageKey, configSelecionadasInicial, usuarioInteragiuComSwitch]);

    return ( 
        <>
            <CabecalhoPadrao 
                titulo={tituloPagina} 
                permissao={"NONE"}
            />

            <div className="wrapper">

                {conteudoExclusivoEsquerda || (
                    <ContainerPadrao
                        titulo={tituloContainer}
                        subtitulo={subtituloContainer}
                        height={10}
                    >
                        <div className="childrenWrapper">
                            {children}
                        </div>
                    </ContainerPadrao>
                )}

                <div className="containeresDireita">

                    {exibeContainerPeriodo && (

                        <ContainerPadrao
                            titulo={tituloContainerPeriodo}
                            subtitulo={subtituloContainerPeriodo}
                            height={10}
                            width={25}
                        >

                        <div className="campoInput">
                            <DatePickerPadrao
                                cresce100={true}
                                required
                                selected={dataInicio}
                                onChange={onChangeDataInicio}
                                placeholder="Selecione a data"
                            >
                                Data início
                            </DatePickerPadrao>

                            <DatePickerPadrao
                                cresce100={true}
                                required
                                selected={horaFinal}
                                onChange={onChangeHoraFinal}
                                placeholder="Selecione a data"
                            >
                                Data final
                            </DatePickerPadrao>
                        </div>

                        </ContainerPadrao>
                        
                    )}

                    <ContainerPadrao
                        titulo={"Configurações do Relatório"}
                        width={25}
                        linhaDivisoria={true}
                    >
                        {/* NOVO: componente extra antes dos checkboxes */}
                        {componenteConfigExtra}
                        {configOptions.length == 0 && (
                            <div className="sem-configuracoes">
                                <p style={{ color: 'var(--cinza-label-input-padrao, #888)' }}>Nenhuma configuração disponível.</p>
                            </div>
                        )}
                        {configOptions.map(opt => (
                            <CheckboxPadrao
                                key={opt.value}
                                label={opt.label}
                                valueId={opt.value}
                                itemsMap={configMap}
                                updateStateCallback={newMap => {
                                    setConfigMap(newMap);
                                    if (salvarConfig) {
                                        onConfigChange(Array.from(newMap.keys()));
                                    }
                                }}
                            />
                        ))}

                        {/* Centraliza o botão de gerar relatório */}
                        <div className="container-botao-centralizado">
                            <BotaoPadrao
                                icon={<RiDownload2Fill />}
                                aoClicar={gerarRelatorio}
                                texto={"Gerar Relatório"}
                            />
                        </div>

                    </ContainerPadrao>
                </div>

            </div>
        </>
    );
}
 
export default TelaRelatorio;